import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import JobsHeader from "./JobsHeader";
import JobsDetailsTab from "./JobsDetailsTab";

function JobsWrap() {

    return (
        <>
            <div className="package-details-wrapper pt-110">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="tour-package-details">
                                <JobsHeader />
                                <JobsDetailsTab />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="package-sidebar">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default JobsWrap;
